import { Translate } from "@/app/application/Translate";
import { Box } from "@mui/material";

export const ArchiveProcedureTourSteps = [
	{
		selector: '[data-tour="archive-procedure"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.ArchiveProcedure.Welcome">
					This is the archive for a single procedure.
				</Translate>
			</Box>
		),
	},
	{
		selector: '[data-tour="archive-procedure-header"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.ArchiveProcedure.Header">
					View procedure details and completion stats. Use "View full data" to
					open the detailed data grid.
				</Translate>
			</Box>
		),
	},
	{
		selector: '[data-tour="archive-procedure-chart"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.ArchiveProcedure.Chart">
					Completions per month — filter by date and user to refine the chart.
				</Translate>
			</Box>
		),
	},
	{
		selector: '[data-tour="archive-procedure-history"]',
		content: (
			<Box sx={{ color: "text.primary" }}>
				<Translate String="Tour.ArchiveProcedure.History">
					History of completed sessions. Filter by date, user, or open a row to
					view full data.
				</Translate>
			</Box>
		),
	},
];
